import React from "react";
import { Vortex } from "./vortex";

export function VortexDemo({ theme = "dark" }: { theme?: "light" | "dark" }) {
  const isLight = theme === "light";

  return (
    <div className="w-full h-full overflow-hidden absolute inset-0">
      <Vortex
        backgroundColor="black"
        className="w-full h-full"
        baseHue={isLight ? 165 : 20}
        rangeHue={isLight ? 45 : 70}
      />
    </div>
  );
} 